import React from 'react'

export default function Mic({ className }) {
  return (
    <svg viewBox="0 0 17 23" className={className}>
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M9.17 18.549v1.76h2.659a.87.87 0 01.872.867.87.87 0 01-.872.867H4.768a.87.87 0 01-.872-.867c0-.48.39-.867.872-.867h2.658v-1.76C3.553 18.192.51 14.943.51 10.998v-.875c0-.479.39-.867.871-.867a.87.87 0 01.872.867v.875c0 3.227 2.639 5.853 5.883 5.853h.324c3.244 0 5.883-2.626 5.883-5.853v-.875a.87.87 0 01.872-.867.87.87 0 01.872.867v.875c0 3.945-3.044 7.194-6.917 7.551zm-1.314-3.727c-2.239-.225-3.873-2.234-3.873-4.473V8.446h3.428a.869.869 0 00.871-.867.87.87 0 00-.871-.868H3.983V5.126c0-2.238 1.634-4.248 3.873-4.473 2.569-.258 4.757 1.765 4.757 4.271v5.628c0 2.506-2.188 4.529-4.757 4.27z"
      />
    </svg>
  )
}
